'use strict';

angular.module('supervisorAuthorizingUserRequestControllers')

.controller('SupervisorAuthorizingRequestController', ['$scope', '$state', '$stateParams', 'topBar', 'supervisorAuthorizingUserRequestService', 'userRequestToAuthorize', 'employee',

function ($scope, $state, $stateParams, topBar, supervisorAuthorizingUserRequestService, userRequestToAuthorize, employee) {

    $scope.request = userRequestToAuthorize.Request;
    $scope.isProcessing = false;
    $scope.systemRoleIdsToCancel = [];

    if (!userRequestToAuthorize.IfAvailable) {
        $state.go('supervisorAuthorizingUserRequest_ByRequest.' + userRequestToAuthorize.Status, {
            userAccessRequestId: $stateParams.userAccessRequestId
        });
    }

    var userAccessRequestId = $scope.request.UserAccessRequestID;

    topBar.setTitleAndIcon('Supervisor Authorization for Request #' + userAccessRequestId, 'fa fa-gavel');

    $scope.approve = function () {
        $scope.isProcessing = true;

        supervisorAuthorizingUserRequestService
            .authorize(userAccessRequestId, $scope.systemRoleIdsToCancel)
            .then(function (response) {

                $scope.isProcessing = false;

                if (!response.IfAvailable) {
                    $state.go('supervisorAuthorizingUserRequest_ByRequest.' + response.Status, {
                        userAccessRequestId: userAccessRequestId
                    });
                }

                else {
                    $state.go('profile', {}, { reload: true });
                }
            });
    };

    // Toggle Mark System Role To Be Cancelled
    $scope.toggleMarkSysRoleToBeCancelled = function (sysRole) {
        sysRole.ToBeCancelled = !sysRole.ToBeCancelled;

        if (sysRole.ToBeCancelled) {
            $scope.systemRoleIdsToCancel.push(sysRole.SystemRoleID);
        } else {
            $scope.systemRoleIdsToCancel = _.pull($scope.systemRoleIdsToCancel, sysRole.SystemRoleID);
        }
    };

    // Has System Some System Roles To Be Cancelled?
    $scope.hasSystemSomeSysRoleToBeCancelled = function (effectiveSystem) {
        return _.some(effectiveSystem.SystemRoles, { ToBeCancelled: true });
    };

    // Check if employee is delegate of supervisor
    if (employee.EmployeeID && employee.EmployeeID !== $scope.request?.Employee?.Supervisor?.EmployeeID) {
      $scope.delegatedSupervisor = $scope.request?.Employee?.Supervisor;
    }
}]);
